<template>
  <div class="floating-cart-box" :class="{ collapsed: isCollapsed }" v-if="isValidProject">
    <div class="cart-toggle" @click="toggleCart" v-if="isCollapsed">
      <font-awesome-icon
        v-if="isCollapsed"
        :icon="['fas', 'chevron-left']"
        class="fa-2x egx-partner-color"
      />
      <div v-if="isCollapsed" class="cart-icon-wrapper">
        <span v-if="currentProject.retrofits && currentProject.retrofits.length > 0" class="cart-counter">
          {{ currentProject.retrofits.length > 9 ? '9+' : currentProject.retrofits.length }}
        </span>
        <font-awesome-icon
          :icon="currentProject.retrofits && currentProject.retrofits.length > 0 ? ['fas', 'dolly-flatbed-alt'] : ['fas', 'dolly-flatbed-empty']"
          class="fa-2x egx-partner-color-white"
        />
      </div>
    </div>
    <div v-if="!isCollapsed" class="cart-content">
      <div class="cart-row">
        <font-awesome-icon
          :icon="['fas', 'chevron-right']"
          class="fa-2x egx-partner-color"
          role="button"
          @click="toggleCart"
        />
        <div class="project-id">
          <span>{{ currentProject.id }}</span>
        </div>
        <div class="cart-button">
          <div class="cart-icon-wrapper">
            <span v-if="currentProject.retrofits && currentProject.retrofits.length > 0" class="cart-counter">
              {{ currentProject.retrofits.length > 9 ? '9+' : currentProject.retrofits.length }}
            </span>
            <font-awesome-icon
              :icon="currentProject.retrofits && currentProject.retrofits.length > 0 ? ['fas', 'dolly-flatbed-alt'] : ['fas', 'dolly-flatbed-empty']"
              class="fa-2x egx-partner-color-white"
              role="button"
              @click="saveCurrentPageToLocalStorage"
            />
          </div>
          <font-awesome-icon
            :icon="['fa', 'info-circle']"
            class="fa-2x egx-partner-color mb-1"
            role="button"
            tabindex="0"
            @click="showModal = !showModal"
          />
        </div>
      </div>
      <div v-if="showModal" class="measure-info">
        <p><strong>Measures:</strong> {{ currentProject.retrofits ? currentProject.retrofits.length : 0 }}</p>
        <p>
          <strong>Total Incentive:</strong> {{ "$" + (currentProject.total_incentive || '0.00') }}
          <span class="text-danger">*</span>
        </p>
        <p class="info-text">
          <span class="text-danger">*</span>
          {{ pageConfiguration.measurecart && pageConfiguration.measurecart.question_text ? pageConfiguration.measurecart.question_text : '' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentProject: Object,
    totalIncentive: [String, Number],
    pageConfiguration: Object,
  },
  data() {
    return {
      showModal: false,
      isCollapsed: !this.cartSettings()?.default_open || false,
    };
  },
  computed: {
    isValidProject() {
      return this.currentProject && Object.keys(this.currentProject).length > 0;
    },
  },
  methods: {
    toggleCart() {
      this.isCollapsed = !this.isCollapsed;
      this.showModal = false;
    },
    saveCurrentPageToLocalStorage() {
      localStorage.setItem('currentPage', this.$route.fullPath);
      this.$router.push({ name: 'ApplicationCart', params: { id: this.$route.params.id } });
    },
    cartSettings() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details.settings.project_measures_cart || {};
    },
  },
};
</script>

<style slang="scss">
@import '../assets//stylesheets/components/project/floating-cart.scss';
</style>
